// extracted by mini-css-extract-plugin
export var active = "_4b-7";
export var container = "_4b-0";
export var evenWidth = "_4b-4";
export var large = "_4b-5";
export var outlet = "_4b-8";
export var slide = "_4b-2";
export var small = "_4b-6";
export var tab = "_4b-3";
export var tabs = "_4b-1";